import UpdateRecurring from "./UpdateRecurring";

export default UpdateRecurring;
